import { styled } from '@mui/material/styles';
import { Grid, Link, Divider, Container, Typography, Stack } from '@mui/material';

export const LINKS = [
  {
    headline: 'Libertas',
    children: [{ name: 'About us', href: 'https://www.libertasfunding.com/about-us/' }],
  },
  {
    headline: 'Legal',
    children: [
      {
        name: 'Terms and Conditions',
        href: 'https://libertasfunding.com/terms-and-conditions',
      },
      {
        name: 'Privacy Policy',
        href: 'https://libertasfunding.com/privacy-policy',
      },
      {
        name: 'CA Privacy Notice',
        href: 'https://libertasfunding.com/california-privacy-notice',
      },
    ],
  },
  {
    headline: 'Contact',
    children: [{ name: 'Contact us', href: 'https://libertasfunding.com/partner-with-us' }],
  },
];

export const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}));

export default function MainFooter() {
  return (
    <footer>
      <RootStyle>
        <Divider />
        <Container sx={{ pt: '5vh' }}>
          <Grid
            container
            justifyContent={{ xs: 'center', md: 'space-between' }}
            sx={{ textAlign: { xs: 'center', md: 'left' } }}
          >
            <Grid item xs={8} md={3}>
              <Typography variant="body2" sx={{ pr: { md: 5 } }}>
                Where relationships are an asset
              </Typography>
            </Grid>

            <Grid item xs={12} md={7}>
              <Stack
                spacing={1}
                direction={{ xs: 'column', md: 'row' }}
                justifyContent="space-between"
              >
                {LINKS.map((list) => (
                  <Stack key={list.headline} spacing={2}>
                    <Typography component="p" variant="overline">
                      {list.headline}
                    </Typography>
                    {list.children.map((link) => (
                      <Link
                        href={link.href}
                        key={link.name}
                        target="_blank"
                        rel="noopener"
                        color="inherit"
                        variant="body2"
                        sx={{ display: 'block' }}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </Stack>
                ))}
              </Stack>
            </Grid>
            <Grid item xs={8} md={3} />
            <Grid item xs={12} md={7}>
              <Typography variant="body2" sx={{ pt: 2 }}>
                If you experience trouble accessing this website or would like to share feedback,
                please contact us at (800) 704-8675. Libertas Funding, LLC’s products and services
                are directed to business customers located in the United States. Libertas Funding,
                LLC NMLS ID# 1972553
              </Typography>
            </Grid>
          </Grid>

          <Typography
            component="p"
            variant="body2"
            sx={{
              mt: 2,
              pb: 5,
              fontSize: 13,
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            © 2025. All rights reserved
          </Typography>
        </Container>
      </RootStyle>
    </footer>
  );
}
